var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{attrs:{"disabled":_vm.disabled,"width":_vm.width},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }